import { call } from 'redux-saga/effects';
import * as Api from '../../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../../helpers/saga';
import { fetchInventorySkuBySku as fetchInventorySkuBySkuRoutine } from './routines';

export const fetchInventorySkuBySku = ({ payload: sku }) =>
  sagaRoutineRequest(fetchInventorySkuBySkuRoutine, {
    request: () => call(Api.fetchInventorySkuBySku, sku)
  });
